import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_select_form = _resolveComponent("select-form");
    const _component_el_col = _resolveComponent("el-col");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_el_table = _resolveComponent("el-table");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
                (_ctx.form)
                    ? (_openBlock(), _createBlock(_component_select_form, {
                        key: 0,
                        modelValue: _ctx.form.schemeId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.form.schemeId) = $event)),
                        label: "Schema",
                        description: "Pilih skema",
                        options: _ctx.schemaOptions,
                        prop: "schemeId",
                        rules: [_ctx.validationRequired()],
                        disabled: _ctx.disabled,
                        onChange: _ctx.changeSchemeId
                    }, null, 8 /* PROPS */, ["modelValue", "options", "rules", "disabled", "onChange"]))
                    : (_openBlock(), _createBlock(_component_select_form, {
                        key: 1,
                        modelValue: _ctx.formData.schemeId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formData.schemeId) = $event)),
                        label: "Schema",
                        description: "Pilih skema",
                        options: _ctx.schemaOptions,
                        disabled: _ctx.disabled,
                        onChange: _ctx.changeSchemeId
                    }, null, 8 /* PROPS */, ["modelValue", "options", "disabled", "onChange"]))
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_el_col, { lg: 12 }, {
            default: _withCtx(() => [
                (_ctx.form)
                    ? (_openBlock(), _createBlock(_component_select_form, {
                        key: 0,
                        modelValue: _ctx.form.assessmentPurposeId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.assessmentPurposeId) = $event)),
                        label: "Tujuan Assessment",
                        description: "Pilih tujuan assessment",
                        options: _ctx.assessmentDestinationOptions,
                        prop: "assessmentPurposeId",
                        rules: [_ctx.validationRequired()],
                        disabled: _ctx.disabled
                    }, null, 8 /* PROPS */, ["modelValue", "options", "rules", "disabled"]))
                    : (_openBlock(), _createBlock(_component_select_form, {
                        key: 1,
                        modelValue: _ctx.formData.assessmentPurposeId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formData.assessmentPurposeId) = $event)),
                        label: "Tujuan Assessment",
                        description: "Pilih tujuan assessment",
                        options: _ctx.assessmentDestinationOptions,
                        disabled: _ctx.disabled
                    }, null, 8 /* PROPS */, ["modelValue", "options", "disabled"]))
            ]),
            _: 1 /* STABLE */
        }),
        _createVNode(_component_el_col, { lg: 24 }, {
            default: _withCtx(() => [
                _createVNode(_component_el_table, { data: _ctx.dataList }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                            label: "No.",
                            type: "index",
                            width: "50",
                            align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Kode Unit Kompetensi",
                            prop: "code",
                            "min-width": "250"
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Judul Unit",
                            prop: "title",
                            width: "auto",
                            "min-width": "250"
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Jenis Standard",
                            prop: "certificationType",
                            align: "center",
                            "min-width": "250"
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["data"])
            ]),
            _: 1 /* STABLE */
        })
    ], 64 /* STABLE_FRAGMENT */));
}
